This is my vue.js page:

<template>
  <div :class="['sidebar', { 'sidebar-closed': isMenuClosed }]">
    <button class="toggle-menu" @click="toggleMenu">
      <i
        :class="[
          'fas',
          {
            'fa-chevron-right': isMenuClosed,
            'fa-chevron-left': !isMenuClosed,
          },
        ]"
      />
    </button>
    <div class="logo-div">
      <img
        v-if="!isMenuClosed"
        class="logo"
        src="~@/assets/logo_tema_escuro.svg"
        alt="Logo do Dashboard"
      />
    </div>
    <div class="separator" />
    <ul class="nav">
      <li
        class="nav-item"
        :class="{ active: $route.path === '/about' }"
        @click="goTo('/about')"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-home" />
          <span class="menu-label">Início</span>
        </a>
      </li>

      <li
        class="nav-item btn-pulse"
        :class="{ active: $route.path === '/' }"
        @click="goToFinancialPLanning"
        v-if="hasDiagnosis"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-crown" />
          <span class="menu-label">Diagnóstico gratuito</span>
        </a>
      </li>

      <li
        v-if="canPurshaseSubscription"
        class="nav-item"
        :class="{ active: $route.path === '/checkout' }"
        @click="goTo('/checkout')"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-star" />
          <span class="menu-label">Assine agora</span>
        </a>
      </li>

      <li
        class="nav-item btn-pulse"
        :class="{ active: $route.path === '/' }"
        @click="goToFinancialPLanning"
        v-if="!hasDiagnosis"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-crown" />
          <span class="menu-label">Meu plano financeiro</span>
        </a>
      </li>

      <OpenFinanceButton v-if="!isMenuClosed" :is-menu-item="true" />

      <span v-if="!isMenuClosed" class="user-tool">Ferramentas do Cliente</span>
      <li
        class="nav-item"
        :class="{ active: $route.path.includes('/cashflow') }"
        @click="goTo('/cashflow/dashboard')"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-solid fa-dollar-sign" />
          <span class="menu-label">Gestão financeira</span>
        </a>
      </li>
      <li
        class="nav-item"
        :class="{ active: $route.path.includes('/planning') }"
        @click="goTo('/planning/future')"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-regular fa-rectangle-list" />
          <span class="menu-label">Linha do futuro</span>
        </a>
      </li>

      <li
        class="nav-item"
        :class="{ active: $route.path.includes('/investments') }"
        @click="goTo('/investments/dashboard')"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-solid fa-chart-column" />
          <span class="menu-label">Gestão de ativos</span>
        </a>
      </li>
      <span v-if="!isMenuClosed" class="user-tool">Benefícios</span>
      <li
        class="nav-item"
        :class="{ disabled: featureDisabled }"
        @click.prevent="openBusinessSchoolLink()"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-solid fa-graduation-cap" />
          <span class="menu-label"> Futuro Academy </span>
        </a>
      </li>
      <li
        class="nav-item"
        :class="{ disabled: featureDisabled }"
        @click.prevent="openBenefitsClubLink()"
      >
        <a class="nav-link" href="#">
          <i class="fas fa-regular fa-gem" />
          <span class="menu-label"> Clube de benefícios </span>
        </a>
      </li>
      <li class="nav-item" @click.prevent="logout()">
        <a class="nav-link" href="#">
          <i class="fas fa-door-open fa-regular" />
          <span class="menu-label"> Sair </span>
        </a>
      </li>
    </ul>
    <Modal
      v-if="blockedByFinancialPlanningNotRead && !isConsultantAccess"
      :title="'Atenção!'"
      :is-open="blockedModalOpen"
      @close="closeBlockedModal"
    >
      <div class="text-center modal-message m-2">
        <p>
          Seu acesso ao Meu Futuro App está bloqueado devido a não confirmação
          do recebimento do seu Plano Financeiro. <br />
          Por favor, acesse o seu plano e confirme o seu recebimento para
          desbloquear o acesso.
        </p>
        <button
          class="btn btn-pulse"
          @click="openFinancialPlanningLink"
          style="color: #ffff"
        >
          <i class="fas fa-crown" />
          <span class="menu-label">Ver meu plano financeiro</span>
        </button>
      </div>
    </Modal>
    <Modal
      v-if="!videoTourReadAt"
      :title="'Bem-vindo'"
      :is-open="welcomeVideoModalOpen"
      video-modal
      @close="closeModal"
      @click="saveInfoReadDate('video_tour')"
    >
      <iframe
        src="https://www.youtube.com/embed/Sf5_Av5JVPU"
        title="Boas vindas ao Futuro App"
        frameborder="0"
        allowfullscreen
        loading="lazy"
        class="responsive-iframe mt-2 w-100"
      ></iframe>
    </Modal>
    <Modal
      v-if="consultantHelpModalOpen"
      :title="'Seu acesso freemium expirou'"
      :is-open="consultantHelpModalOpen"
      @close="closeConsultantHelpModal"
    >
      <div class="text-center modal-message m-2">
        <div class="mb-3">
          <i class="fas fa-clock text-warning" style="font-size: 3rem;"></i>
        </div>
        <h5 class="mb-3">Seu período de teste gratuito chegou ao fim!</h5>
        <p class="mb-3">
          Não se preocupe! Um de nossos consultores especializados entrará em contato com você em breve para:
        </p>
        <ul class="text-left mb-4" style="max-width: 400px; margin: 0 auto;">
          <li class="mb-2">
            <i class="fas fa-check text-success me-2"></i>
            Apresentar nossos planos de assinatura
          </li>
          <li class="mb-2">
            <i class="fas fa-check text-success me-2"></i>
            Auxiliar na escolha do melhor plano para você
          </li>
          <li class="mb-2">
            <i class="fas fa-check text-success me-2"></i>
            Esclarecer todas as suas dúvidas
          </li>
          <li class="mb-2">
            <i class="fas fa-check text-success me-2"></i>
            Oferecer condições especiais
          </li>
        </ul>
        <p class="text-muted mb-4">
          <small>
            <i class="fas fa-phone me-1"></i>
            Aguarde nosso contato nos próximos dias úteis ou entre em contato conosco pelo WhatsApp.
          </small>
        </p>
        <div class="d-flex justify-content-center gap-3">
          <button
            class="btn btn-pulse px-4"
            @click="goToSubscription"
            style="color: #ffff; background: linear-gradient(252deg, #65a0ff, #24b3e8);"
          >
            <i class="fas fa-star me-2" />
            Ver planos de assinatura
          </button>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { useAppStore } from "@/store/store.js";
import Modal from "@/components/shared/Modal.vue";
import OpenFinanceButton from "../components/open_finance/OpenFinanceButton.vue";
export default {
  components: {
    Modal,
    OpenFinanceButton,
  },
  data() {
    return {
      isMenuClosed: false,
      currentRoute: "/cashflow/dashboard",
      welcomeVideoModalOpen: false,
      blockedModalOpen: true,
      consultantHelpModalOpen: false
    };
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
    this.checkConsultantHelpModal();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  watch: {
    // Observa mudanças no estado do usuário para mostrar o modal quando necessário
    shouldShowConsultantHelpModal(newValue) {
      const modalClosed = localStorage.getItem('consultantHelpModalClosed');
      if (newValue && !modalClosed && !this.consultantHelpModalOpen) {
        this.consultantHelpModalOpen = true;
      }
    }
  },
  computed: {
    featureDisabled() {
      const store = useAppStore();
      return !store.hasAdditionalBenefits();
    },
    hasFinancialPlan() {
      const store = useAppStore();
      return store.financialPlanningLink;
    },
    isFreemium() {
      const store = useAppStore();
      return store.isFreemiumAccess();
    },
    videoTourReadAt() {
      const store = useAppStore();
      if (store.user?.video_tour_read_at === null) {
        this.openWelcomeVideoModal();
      }
      return store.user?.video_tour_read_at || undefined;
    },
    canPurshaseSubscription() {
      const store = useAppStore();
      return (
        this.isFreemium ||
        (!store.hasCashFlowAccess() && !store.hasPlanningAccess())
      );
    },
    blockedByFinancialPlanningNotRead() {
      const store = useAppStore();
      return store.financialPlanningNotRead();
    },
    shouldShowConsultantHelpModal() {
      const store = useAppStore();
      const user = store.userResponse?.data?.userInfo;
      const userFastapp = store.userResponse?.data?.userFastapp;
      
      return userFastapp && 
             (userFastapp.freemium_remaining_time <= 0) && 
             !store.hasSubscriptionActive && 
             !user?.financial_management_active &&
             !user?.is_pn_employee &&
             !user?.other_running_products;
    },
    hasDiagnosis() {
      const store = useAppStore();
      let user = store.userResponse?.data?.userInfo;
      let has_finished_pre_interview =  user?.hasFinishedPreInterview || false;
      return this.isFreemium && !has_finished_pre_interview;
    },
    isConsultantAccess() {
      const store = useAppStore();
      return store.sessionInfo?.consultant_id != null;
    },
  },
  methods: {
    openWelcomeVideoModal() {
      this.welcomeVideoModalOpen = true;
    },
    closeModal() {
      this.welcomeVideoModalOpen = false;
    },
    closeBlockedModal() {
      this.blockedModalOpen = false;
    },
    closeConsultantHelpModal() {
      this.consultantHelpModalOpen = false;
    },
    checkConsultantHelpModal() {
      setTimeout(() => {
        if (this.shouldShowConsultantHelpModal) {
          this.consultantHelpModalOpen = true;
        }
      }, 5000);
    },
    goToSubscription() {
      this.closeConsultantHelpModal();
      this.$router.push('/checkout');
    },
    toggleMenu() {
      this.isMenuClosed = !this.isMenuClosed;
      this.$emit("menu-toggle", this.isMenuClosed);
    },
    goTo(route) {
      this.$router.push(route);
      this.currentRoute = route;
    },
    async goToPreInterview(route) {
      const store = useAppStore();
      await store.goToPreInterview();
    },
    async goToFinancialPLanning(route) {
      const store = useAppStore();
      if (this.hasFinancialPlan) {
        const linkUrl = store.financialPlanningLink;
        window.open(linkUrl, "_blank");
      } else {
        await store.goToFinancialPLanning(route);
      }
    },
    async saveInfoReadDate(type) {
      const store = useAppStore();
      await store.saveInfoReadDate(type);
    },
    checkScreenSize() {
      const screenWidth = window.innerWidth;
      if (screenWidth <= 767) {
        // Defina o limite de largura para dispositivos móveis ou tablets
        this.isMenuClosed = true;
        this.$emit("menu-toggle", this.isMenuClosed);
      } else {
        this.isMenuClosed = false;
        this.$emit("menu-toggle", this.isMenuClosed);
      }
    },
    openFinancialPlanningLink() {
      const store = useAppStore();
      const linkUrl = store.financialPlanningLink;
      window.location.replace(linkUrl);
    },
    openBusinessSchoolLink() {
      if (this.featureDisabled) {
        this.$toast.add({
          severity: "warn",
          summary: "Recurso indisponível",
          detail: "Essa ferramenta não está incluída no plano contratado.",
          life: 5000,
        });
      } else if (!this.menuItemDisabled) {
        setTimeout(() => {
          window
            .open(process.env.VUE_APP_BUSINESS_SCHOOL_URL, "_blank")
            .focus();
        });
      }
    },
    openBenefitsClubLink() {
      if (this.featureDisabled) {
        this.$toast.add({
          severity: "warn",
          summary: "Recurso indisponível",
          detail: "Essa ferramenta não está incluída no plano contratado.",
          life: 5000,
        });
      } else if (!this.menuItemDisabled) {
        setTimeout(() => {
          window.open(process.env.VUE_APP_BENEFITS_CLUB_URL, "_blank").focus();
        });
      }
    },
    soon() {
      alert("Em breve!");
    },
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("session_info");
      window.location.href = "/login";
    },
    checkFeatureDisabled() {
      if (this.featureDisabled) {
        this.$toast.add({
          severity: "warn",
          summary: "Recurso indisponível",
          detail: "Essa ferramenta não está incluída em seu plano contratado.",
          life: 5000,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* A largura, a proporção 16:9 e a altura são definidas pela variante .video-size do Modal */
.responsive-iframe {
  display: block;
  width: 100%;
  border: none;
}
.video-overlay-button {
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  cursor: pointer;
  z-index: 10;
}
a {
  padding: 0;
}
.logo-div {
  display: flex;
  justify-content: center;
  align-items: center;
}
.user-tool {
  text-transform: uppercase;
  text-align: left;
  font-size: 13px;
  letter-spacing: 0.6px;
  color: #676d7d;
  opacity: 1;
  margin: 20px 0 8px 0;
}

ul {
  list-style-type: none;
  padding-left: 0;
  li {
    margin: 2px 0;
    width: 100%;
  }
}
.nav-link {
  display: flex;
  align-items: center;
  color: #fff !important;
  padding: 8px;
  border: none;
  font-size: 15px;
  i {
    color: #ffffff;
    margin-right: 10px;
  }

  span:hover {
    font-weight: bold;
  }
}

.nav-link:hover {
  background: #cb5540 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 10px #f26236ad;
  border-radius: 4px;
  opacity: 0.97;
}
.logo {
  width: 100%;
  max-width: 215px;
  margin: 0 !important ;
}

.dashboard {
  display: flex;
  height: 100vh;
}

.active {
  background: #cb5540 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 0.97;
}

.sidebar {
  width: 255px;
  background-color: #283045;
  padding: 20px;
  position: absolute;
  top: 0;
  z-index: 900;
  left: 0;
  bottom: 0;
}

.sidebar-closed {
  width: 75px;
  i {
    padding: 10px 0;
  }
}
ul {
  list-style-type: none;
  padding-left: 0;
  text-align: left;
  margin: 0;
}

.nav-item {
  transition: padding-left 0.3s ease;
}

.sidebar-closed .nav-item {
  padding-left: 0;
}

.toggle-menu {
  position: absolute;
  bottom: 20px;
  left: 10px;
  padding: 5px;
  color: #fff;
  background-color: #f1f1f100;
  border: none;
  cursor: pointer;
}

.fa-chevron-left,
.fa-chevron-right {
  transition: transform 0.3s ease;
}

.sidebar-closed .fa-chevron-left {
  transform: rotate(180deg);
}

.sidebar-closed .fa-chevron-right {
  transform: rotate(0deg);
}

.menu-label {
  display: inline-block;
  margin-left: 10px;
}

.sidebar-closed .menu-label {
  display: none;
}

.disabled {
  opacity: 0.4;
}

.btn-pulse {
  background-image: linear-gradient(252deg, #65a0ff, #24b3e8);
  border-radius: 4px;
}

.modal-message {
  color: #fff;
  font-size: 16px;
  margin-bottom: 30px;
  line-height: 1.5;
  
  h5 {
    color: #fff;
    font-weight: bold;
  }
  
  ul {
    list-style: none;
    padding: 0;
    
    li {
      margin-bottom: 10px;
      display: flex;
      align-items: center;
      
      i.fa-check {
        margin-right: 10px;
        font-size: 14px;
      }
    }
  }
  
  .text-success {
    color: #28a745 !important;
  }
  
  .text-warning {
    color: #ffc107 !important;
  }
  
  .text-muted {
    color: #6c757d !important;
  }
  
  .d-flex {
    display: flex;
  }
  
  .justify-content-center {
    justify-content: center;
  }
  
  .gap-3 {
    gap: 1rem;
  }
  
  .btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    transition: all 0.3s ease;
    
    &:hover {
      transform: translateY(-2px);
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
